module.exports = __webpack_public_path__ + "assets/img/zzzm.1ba99728.png";